<script>
	import { slide } from 'svelte/transition';

	export let items = [];

	let openIndex = null;

	const toggle = (index) => {
		openIndex = openIndex === index ? null : index;
	};
</script>

<div class="accordion">
	{#each items as item, i}
		<div class="item">
			<button
				type="button"
				class="header"
				on:click={() => toggle(i)}
				aria-expanded={openIndex === i}
				aria-controls={`section-${i}`}
				id={`accordion-header-${i}`}
			>
				{item.title}
			</button>

			{#if openIndex === i}
				<div
					class="content"
					id={`section-${i}`}
					role="region"
					aria-labelledby={`accordion-header-${i}`}
					transition:slide
				>
					{@html item.content}
				</div>
			{/if}
		</div>
	{/each}
</div>
